import { render, staticRenderFns } from "./TabberFaqs.vue?vue&type=template&id=db14bac6"
import script from "./TabberFaqs.vue?vue&type=script&lang=ts"
export * from "./TabberFaqs.vue?vue&type=script&lang=ts"
import style0 from "./TabberFaqs.vue?vue&type=style&index=0&id=db14bac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports